import { useContext } from 'react';

import { CategoricalBarChartValueFormatter } from '../contexts/CategoricalBarChartValueFormatter.context.js';

export const useFormatter = () => {
  const context = useContext(CategoricalBarChartValueFormatter);

  if (context === undefined) {
    throw new Error(
      'useFormatter must be used within a CategoricalBarChartValueFormatter',
    );
  }

  return context;
};
